/**
 * 移動端身份識別頁面（頁面沒有實際需要渲染的內容，只有一些邏輯），如：
 * 1. 獲取身份識別地址
 * 2. 打開身份識別
 * 3. 處理身份識別結果
 */
/* eslint-disable react/require-default-props */
import { forwardRef, useContext, useEffect, useImperativeHandle } from 'react';
import { Auth, Storage } from '@gov-mo/mpaas-js-bridge';
import { Toast } from 'antd-mobile';
import usePersistFunc from '@/hooks/usePersistFunc';
import { securityLevel } from '@/utils/ServiceConf';
import { UserState, useSelector } from 'umi';
import { getFirstFaceUrl } from '../../services/serviceStepApi';
import StepContext from '../StepRender/StepContext';

export interface IdentityAuthProps {
  onSuccess?: () => void;
  onFail?: () => void;
  authLevel: securityLevel;
}

/**
 * 调用身份识别方法
 * @param authLevel 安全級別
 * @param authUrl 身份識別地址
 */
export const startAuth = (authLevel: securityLevel, authUrl: string) => {
  Storage.get('userType').then((res: { success: boolean; data?: string }) => {
    if (res.success && typeof res.data === 'string') {
      Auth.start({
        accountType: res.data.toUpperCase(),
        identityLevel: securityLevel[authLevel],
        reason: '',
        authUrl,
      });
    } else {
      Toast.fail('');
    }
  });
};

/**
 * 獲取身份識別地址並调用身份识别方法
 * @param param0
 */
export const handleAuth = ({ authLevel }: { authLevel: securityLevel }, euidParam?: () => void) => {
  getFirstFaceUrl({ channel: 'app', euid: euidParam }).then((res) => {
    // 新窗口打開身份識別地址
    startAuth(authLevel, res.data);
  });
};

/**
 * 组件
 * @param props
 * @param ref
 * @returns
 */
function IdentityAuth(props: IdentityAuthProps, ref) {
  const { onSuccess, authLevel, onFail } = props;
  const { profile } = useSelector(({ user }: { user: UserState }) => user);
  const context = useContext(StepContext);
  // 身份识别回调
  const onRecognitionFinish = usePersistFunc(
    (e: { data: { success: boolean; data: { error: string; code: string; id: string } } }) => {
      const { data } = e;
      if (data.success) {
        if (onSuccess) {
          onSuccess();
        }
      } else {
        onFail?.();
      }
    },
  );

  /**
   * 將handleAuth方法暴露給組件外部掉用
   */
  useImperativeHandle(ref, () => ({
    handleAuth,
  }));

  /**
   * 監聽身份識別結果
   */
  useEffect(() => {
    document.addEventListener('identity-auth', onRecognitionFinish);
    if (!context.isAuth) {
      handleAuth({ authLevel }, profile.euid);
    }
    return () => {
      document.removeEventListener('identity-auth', onRecognitionFinish);
    };
  }, []);
  return null;
}

export default forwardRef(IdentityAuth);
